import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import authService from '@/data/api/authService';

export function useAuthLink() {
  const route = useRoute();
  const isAuthenticated = ref(false);

  const checkAuth = () =>
    authService.restoreAuth().then((valid) => (isAuthenticated.value = valid));

  onMounted(checkAuth);
  watch(() => route.fullPath, checkAuth);

  return computed(() => {
    if (isAuthenticated.value) {
      return {
        name: 'logout',
        route: { name: 'logout' },
        icon: 'nf nf-oct-sign_out',
        label: 'Logout',
        color: 'error',
        authenticated: true
      };
    }
    if (route.name === 'login') {
      return {
        name: 'signup',
        route: { name: 'signup' },
        icon: 'mdi-account-plus',
        label: 'Sign Up',
        color: 'secondary',
        authenticated: false
      };
    }
    return {
      name: 'login',
      route: { name: 'login' },
      icon: 'mdi-login',
      label: 'Login',
      color: 'primary',
      authenticated: false
    };
  });
}
